import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  SimpleChanges
} from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from "@angular/material/dialog";
import { VoucherService } from "../../data-service/voucher.service";
import { AlertService } from "src/app/share/service/alert.service";
import {
  CheckerInterface,
  PromoCodeInterface,
  ReferralCodeInterface
} from "src/app/share/interface/motor.interface";
import { VoucherType } from "./voucher-enum";
import { MotorDataDataService } from "src/app/share/data-service/motor.data.service";

@Component({
  selector: "app-voucher-dialog",
  templateUrl: "./voucher-dialog.component.html",
  styleUrls: ["./voucher-dialog.component.scss"]
})
export class VoucherDialogComponent implements OnInit {
  finalAmount: number = 0;
  finalAmountAfterDiscount: number = 0;
  finalDiscountAmount: number = 0;
  discountAmountCash: number = 0;
  discountAmountPromo: number = 0;
  discountAmountReferral: number = 0;

  promoCodeType!: PromoCodeInterface[];
  promoVoucherList?: PromoCodeInterface[];
  cashVoucherList?: PromoCodeInterface[];
  vehicleNumber: string = "";

  selectedPromoVoucher?: PromoCodeInterface;
  selectedCashVoucher?: PromoCodeInterface;
  selectedReferralVoucher?: PromoCodeInterface;
  selectedVoucher?: PromoCodeInterface[];
  selectedVoucherCodes?: string[];

  disabledPromoVoucher: boolean = false;
  disabledCashVoucher: boolean = false;

  voucherCode?: string;
  voucherErrorDesc?: string;
  referralErrorDesc?: string;
  cashErrorDesc?: string;
  promoErrorDesc?: string;

  inputVoucher!: PromoCodeInterface | undefined;
  isReferralCode: boolean = false;
  isCashVoucerCode: boolean = false;
  isPromoVoucerCode: boolean = false;
  referralCode?: string;

  personalIdentificationNo!: string;
  quotationId!: string;
  lang!: string;
  personalInfo: any;

  referral?: ReferralCodeInterface;

  private suppressNextAmountRefetch: boolean = false;

  @Output() onClose = new EventEmitter();
  @Output() voucherCodeList = new EventEmitter<PromoCodeInterface[]>();
  @Input() plateNumber: string = "";
  @Input() openVoucher: boolean = false;
  @Input() totalAmountMobile?: number;
  @Input() quoteId: string = "";
  @Input() identityNumber: string = "";
  @Input() voucherListCode: string[] = [];

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    private data: {
      totalAmount?: number;
      totalAmountAfterDiscount?: number;
      vehicleNo?: string;
      voucherListCode?: string[];
      quotationId: string;
      identityNo: string;
      referralCode?: string;
      errors?: string[];
    },
    @Optional()
    private dialogRef: MatDialogRef<VoucherDialogComponent>,
    private voucherService: VoucherService,
    private motorDataDataService: MotorDataDataService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.vehicleNumber = this.data?.vehicleNo ?? this.plateNumber;
    this.finalAmount = this.data?.totalAmount ?? this.totalAmountMobile ?? 0;
    this.finalAmountAfterDiscount = this.data?.totalAmountAfterDiscount ?? 0;
    this.finalDiscountAmount = this.finalAmount - this.finalAmountAfterDiscount;
    this.personalIdentificationNo = this.data?.identityNo ?? this.identityNumber;
    this.quotationId = this.data?.quotationId ?? this.quoteId;
    this.getVoucherByVehicleNo();

    if (!this.referralCode && this.data?.referralCode) {
      this.referralCode = this.data.referralCode;
      this.selectedReferralVoucher = {} as PromoCodeInterface;
      this.selectedReferralVoucher.code = this.referralCode;
      this.selectedReferralVoucher.type = VoucherType.Referral;
      this.applyReferralCode();
    }
  }

  applyReferralCode() {
    if (!this.referralCode) return;
    this.voucherErrorDesc = undefined;

    this.motorDataDataService
      .applyReferralCode(
        this.quotationId,
        this.referralCode,
        this.personalIdentificationNo
      )
      .subscribe({
        next: (x) => {
          this.referral = x;
          this.isReferralCode = true;
          this.referralErrorDesc = undefined;
        },
        error: (err) => {
          this.isReferralCode = false;
          this.referralErrorDesc = err.error.message;
          this.referral = undefined;
          console.error("error referral:",err.error.message);
          this.voucherCode = undefined;
        }
      });
  }

  closeVoucherInputMobile() {
    this.onClose.emit();
  }

  closeVoucherInput() {
    this.dialogRef.close();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["openVoucher"] && !changes["openVoucher"].firstChange) {
      this.getVoucherByVehicleNo();
    }
    if (changes['totalAmountMobile']) {
      this.finalAmount = this.totalAmountMobile ?? this.data?.totalAmount ?? 0;

      if (this.suppressNextAmountRefetch) {
        this.suppressNextAmountRefetch = false;
      } else {
        this.getVoucherByVehicleNo();
      }
    }
    if (
      changes['voucherListCode'] &&
      !changes['voucherListCode'].firstChange &&
      (this.promoVoucherList || this.cashVoucherList)
    ) {
      this.resyncSelectedVouchers();
    }
  }

  private resyncSelectedVouchers() {
    this.selectedVoucherCodes =
      this.data?.voucherListCode ?? this.voucherListCode;

    this.selectedPromoVoucher = this.promoVoucherList?.find((col) =>
      this.selectedVoucherCodes?.includes(col.code)
    );

    this.selectedCashVoucher = this.cashVoucherList?.find((col) =>
      this.selectedVoucherCodes?.includes(col.code)
    );

    this.onPromoSelected(false);
    this.onCashSelected(false);
  }

  updateVoucher(totalAmount: number, totalDiscount: number) {
    // this.finalAmount = totalAmount;
    this.finalAmountAfterDiscount = totalAmount;
    this.finalDiscountAmount = totalDiscount;
  }

  removeReferralVoucher() {
    this.referralCode = undefined;
    this.isReferralCode = false;
    this.voucherErrorDesc = undefined;
    this.referralErrorDesc = undefined;
  }

  // checkVoucherType(code: string): CheckerInterface {
  //   this.voucherService.checkPromoOrReferral(code).subscribe((result) => {
  //     return result;
  //   })
  // }

  applyCode() {
    this.voucherErrorDesc = undefined;
    this.referralErrorDesc = undefined;
    
    this.voucherService.getReferralCode(this.voucherCode!,this.finalAmount,this.vehicleNumber).subscribe({
      next: (x: any) => {
        this.voucherService
          .checkPromoOrReferral(this.voucherCode!)
          .subscribe((result) => {
            if (result.type == "PromoCode") {
              this.inputVoucher = x;

              const existsInList = (list?: any[]) =>
                list?.some((v) => v.id === this.inputVoucher.id);

              if (!this.inputVoucher) {
                this.voucherErrorDesc =
                  "The code you’ve entered is either invalid or expired.";
              } else if (
                existsInList(this.promoVoucherList) ||
                existsInList(this.cashVoucherList)
              ) {
                this.voucherErrorDesc =
                  "You've already applied this voucher code.";
              } else if (
                this.inputVoucher.type === VoucherType.Promo &&
                this.disabledPromoVoucher
              ) {
                this.promoErrorDesc = "voucher.campaignNotApplicable";
              } else if (this.inputVoucher) {
                this.inputVoucher.fullyRedeemed =
                  this.inputVoucher.limit != null &&
                  (this.inputVoucher.redeemedCount ?? 0) >= this.inputVoucher.limit;
                this.inputVoucher.remainingPercentage =
                  this.calculateRemainingPercentage(this.inputVoucher);

                const isPromo = this.inputVoucher.type === VoucherType.Promo;
                if (isPromo) {
                  this.promoVoucherList?.unshift(this.inputVoucher);

                  // this.promoVoucherList?.forEach((col) => {
                  //   col.disabled = col !== this.inputVoucher;
                  // });

                  this.selectedPromoVoucher = this.inputVoucher;
                  this.onPromoSelected();
                } else {
                  this.cashVoucherList?.unshift(this.inputVoucher);

                  // this.cashVoucherList?.forEach((col) => {
                  //   col.disabled = col !== this.inputVoucher;
                  // });

                  this.selectedCashVoucher = this.inputVoucher;
                  this.onCashSelected();
                }
                this.referralErrorDesc = undefined;
                this.voucherErrorDesc = undefined;
              }
            }
            else if (result.type == "Referral") {
              if(this.referralCode && this.voucherCode && this.referralCode === this.voucherCode){
                this.voucherCode = undefined;
                  this.referralErrorDesc =
                  "duplicateReferral";
              } else {
                this.voucherErrorDesc = undefined;
                this.referralCode = this.voucherCode;
                this.applyReferralCode();
                this.selectedReferralVoucher = {} as PromoCodeInterface;
                this.selectedReferralVoucher.code = this.voucherCode!;
                this.selectedReferralVoucher.type = VoucherType.Referral ;
                this.onReferralSelected(); 
              }
            }
            else {
              this.voucherErrorDesc =
                  "The code you’ve entered is either invalid or expired.";
            }

          });
      },
      error: (err) => {
        this.alertService.openSnackBar(`Error: ${err.message}`);
        console.log(err);
      }
    });
  }

  applyVoucher() {
    const numberOfVoucher =
      (this.selectedPromoVoucher ? 1 : 0) + (this.selectedCashVoucher ? 1 : 0);

    const voucherCodes = [
      this.selectedPromoVoucher?.code,
      this.selectedCashVoucher?.code
    ].filter(Boolean);

    const voucherIds = [
      this.selectedPromoVoucher?.id,
      this.selectedCashVoucher?.id
    ].filter(Boolean);

    this.dialogRef.close({
      numberOfVoucher: numberOfVoucher,
      listOfVoucherCodes: voucherCodes,
      listOfVoucherIds: voucherIds,
      referralCode: this.referralCode
    });
  }

  handleClick(event: Event, type: string) {
    this.voucherErrorDesc = undefined;
    if (type == VoucherType.Promo) {
      if (this.isPromoVoucerCode) {
        event.preventDefault();
        this.cashErrorDesc =
          "RAF473DEB14";
        return;
      } else {
        if(this.data?.errors && this.data?.errors?.length > 0){
          this.data.errors.forEach((errMessage) => {
            this.cashErrorDesc = errMessage
          })
        }
        else {
          this.onPromoSelected();
        }
      }
    } else {
      if (this.isCashVoucerCode) {
        event.preventDefault();
        this.cashErrorDesc =
          "You’ve already applied a Cash code. Remove it to use a different one.";
        return;
      } else {
        if(this.data?.errors && this.data?.errors?.length > 0){
          this.data.errors.forEach((errMessage) => {
            this.cashErrorDesc = errMessage
          })
        }
        else {
          this.onCashSelected();
        }
      }
    }
  }

  handleDoubleClick(event: MouseEvent, type: string, voucher: any) {
    const input = event.target as HTMLInputElement;

    if (type === VoucherType.Promo) {
      if (this.selectedPromoVoucher === voucher) {
        this.selectedPromoVoucher = undefined;
        this.onPromoSelected();
        input.checked = false;
      }
    } else {
      if (this.selectedCashVoucher === voucher) {
        this.selectedCashVoucher = undefined;
        this.onCashSelected();
        input.checked = false;
      }
    }

    this.updateFinalAmount();
  }

  onCashSelected(emit: boolean = true) {
    this.discountAmountCash = this.getTotalDiscount(this.selectedCashVoucher!);

    this.updateFinalAmount(emit);
  }

  onPromoSelected(emit: boolean = true) {
    this.discountAmountPromo = this.getTotalDiscount(
      this.selectedPromoVoucher!
    );

    this.updateFinalAmount(emit);
  }

  onReferralSelected() {
    const referralList: PromoCodeInterface[] = []

    referralList.push(this.selectedReferralVoucher!);

    this.updateFinalAmount();
  }

  private getTotalDiscount(voucher: PromoCodeInterface): number {
    const formula = voucher?.evaluate;

    if (!formula) {
      return 0;
    }
    try {
      if (formula.includes("{TotalGrossPremium}")) {
        const expression = formula.replace(
          "{TotalGrossPremium}",
          ((this.data?.totalAmount ?? this.totalAmountMobile) || 0).toString()
        );

        return new Function(`return ${expression}`)();
      } else {
        return Number(formula);
      }
    } catch (err) {
      console.error("Invalid formula:", formula);
      return 0;
    }
  }

  private updateFinalAmount(emit: boolean = true) {
    this.finalAmount = this.data?.totalAmount ?? this.totalAmountMobile ?? 0;

    if (!emit) {
      return;
    }

    this.suppressNextAmountRefetch = true;

    this.selectedVoucher = [
      this.selectedPromoVoucher,
      this.selectedCashVoucher,
      this.selectedReferralVoucher
      ].filter(v => !!v);

    this.voucherCodeList.emit(this.selectedVoucher);
    
  }

  //For Urgency Showing Remaining Bar
  private calculateRemainingPercentage(voucher: PromoCodeInterface): number {
    const startingPercentage = voucher.startingPercentage ?? 0;
    const usageSpeed = voucher.usageSpeed;
    const redeemedCount = voucher.redeemedCount ?? 0;

    if (!usageSpeed) {
      return startingPercentage;
    }

    return Math.max(
      5,
      startingPercentage - Math.floor(redeemedCount / usageSpeed)
    );
  }

  checkOnGoingCampaign() {
    this.voucherService.campaignOnGoing().subscribe((result) => {
      this.disabledPromoVoucher = result;
      if(result){
        this.promoErrorDesc = "voucher.campaignNotApplicable"
      }
    })
  }

  //Api functions
  getVoucherByVehicleNo() {
    this.selectedVoucherCodes =
      this.data?.voucherListCode ?? this.voucherListCode;
    

    if (!this.vehicleNumber || !this.finalAmount) {
      return;
    }
    this.voucherService
      .getVoucherListByVehicleNo(this.vehicleNumber, this.finalAmount, this.selectedVoucherCodes)
      .subscribe({
        next: (x: any) => {
          this.promoCodeType = x;
          this.promoVoucherList = this.promoCodeType
            ?.filter((col) => col.type === VoucherType.Promo)
            .map((col) => ({
              ...col,
              fullyRedeemed:
                col.limit != null && (col.redeemedCount ?? 0) >= col.limit,
              remainingPercentage: this.calculateRemainingPercentage(col)
            }))
            //available vouchers first, fully redeemed/disabled ones last
            .sort(
              (a, b) =>
                Number(!!(a.fullyRedeemed || a.disabled)) -
                Number(!!(b.fullyRedeemed || b.disabled))
            );

          this.cashVoucherList = this.promoCodeType
            ?.filter((col) => col.type === VoucherType.Cash)
            .map((col) => ({
              ...col,
              fullyRedeemed:
                col.limit != null && (col.redeemedCount ?? 0) >= col.limit,
              remainingPercentage: this.calculateRemainingPercentage(col)
            }))
            //available vouchers first, fully redeemed/disabled ones last
            .sort(
              (a, b) =>
                Number(!!(a.fullyRedeemed || a.disabled)) -
                Number(!!(b.fullyRedeemed || b.disabled))
            );

          this.resyncSelectedVouchers();
          this.checkOnGoingCampaign();
        },
        error: (err) => {
          this.alertService.openSnackBar(`Error: ${err.message}`);
          console.log(err);
        }
      });
  }
}
